import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "../api";
import { readAdminPageCache, writeAdminPageCache } from "../utils/adminPageCache";

const Datacontext = createContext(null);

const DASHBOARD_CHART_CACHE_KEY = "dashboard-chart-orders";
const dashboardChartSnapshot =
  readAdminPageCache(DASHBOARD_CHART_CACHE_KEY, 3 * 60 * 1000) || {};
const cachedOrders = Array.isArray(dashboardChartSnapshot.orders)
  ? dashboardChartSnapshot.orders
  : [];

const Context = ({ children }) => {
  const [orders, setOrders] = useState(cachedOrders);
  const [loading, setLoading] = useState(cachedOrders.length === 0);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      setOrders([]);
      setLoading(false);
      return undefined;
    }

    let isMounted = true;

    const fetchData = async () => {
      try {
        const res = await axios.get("/order/orders", {
          params: { compact: "chart" },
        });
        if (!isMounted) return;
        const nextOrders = Array.isArray(res?.data?.order) ? res.data.order : [];
        setOrders(nextOrders);
        writeAdminPageCache(DASHBOARD_CHART_CACHE_KEY, { orders: nextOrders });
      } catch (error) {
        console.log(error);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchData();
    const timer = window.setInterval(fetchData, 20000);

    return () => {
      isMounted = false;
      window.clearInterval(timer);
    };
  }, [token]);

  const contextValue = useMemo(() => ({ orders, loading }), [orders, loading]);

  return <Datacontext.Provider value={contextValue}>{children}</Datacontext.Provider>;
};

const ContextAuth = () => {
  return useContext(Datacontext);
};

export { Context, ContextAuth };
